import { useState } from "react";
import { Mail, Send } from "lucide-react";

const SUPPORT_EMAIL = "cria.finance@gmail.com";

export default function SupportSection() {
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const send = (e) => {
    e.preventDefault();
    const s = encodeURIComponent(subject || "Dúvida / Reclamação — CRIA FINANCE");
    const b = encodeURIComponent(
      `Nome: ${name || "-"}\n\n${message || ""}\n\n---\nEnviado pelo site cria.finance`
    );
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${s}&body=${b}`;
  };

  return (
    <section data-testid="support-section" className="border-t border-white/[0.06] bg-[#0A0A0A]">
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-16 grid md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <span className="sticker">SUPORTE</span>
          <h2 className="mt-6 font-bebas text-5xl md:text-6xl tracking-tighter">
            DÚVIDAS &<br/><span className="text-[#CCFF00]">RECLAMAÇÕES</span>
          </h2>
          <p className="mt-4 text-white/70 font-manrope">
            Fala com a gente. Responde em até 48h úteis.
          </p>
          <a
            data-testid="support-mailto"
            href={`mailto:${SUPPORT_EMAIL}?subject=D%C3%BAvida%20-%20CRIA%20FINANCE`}
            className="mt-6 inline-flex items-center gap-2 font-manrope text-[#CCFF00] hover:underline break-all"
          >
            <Mail size={18}/> {SUPPORT_EMAIL}
          </a>
        </div>

        <form onSubmit={send} className="md:col-span-7 brutal-card space-y-4" style={{borderColor:'#CCFF00'}}>
          <div>
            <label className="font-manrope text-xs uppercase tracking-widest text-white/60">Seu nome</label>
            <input
              data-testid="support-name"
              value={name}
              onChange={(e)=>setName(e.target.value)}
              placeholder="Como você quer ser chamado"
              className="brutal-input mt-2"
            />
          </div>
          <div>
            <label className="font-manrope text-xs uppercase tracking-widest text-white/60">Assunto</label>
            <input
              data-testid="support-subject"
              value={subject}
              onChange={(e)=>setSubject(e.target.value)}
              placeholder="Ex: Problema com pagamento Pix"
              className="brutal-input mt-2"
            />
          </div>
          <div>
            <label className="font-manrope text-xs uppercase tracking-widest text-white/60">Mensagem</label>
            <textarea
              data-testid="support-message"
              value={message}
              onChange={(e)=>setMessage(e.target.value)}
              rows={5}
              required
              placeholder="Descreve o que aconteceu ou tua dúvida..."
              className="brutal-input mt-2 resize-none"
            />
          </div>
          <button data-testid="support-send" type="submit" className="brutal-btn w-full flex items-center justify-center gap-2">
            <Send size={18}/> Enviar mensagem
          </button>
          <p className="text-white/40 font-manrope text-xs text-center">
            Vai abrir seu app de e-mail com a mensagem pronta pra enviar.
          </p>
        </form>
      </div>
    </section>
  );
}
